import React from "react";
import "./tooltip.css";

const lightColors = {
  Booked: "gray",
  Changed: "yellow",
  Cancelled: "red",
  "Cancelled - No Fee": "red",
  "Cancelled - Charge Fee": "red",
  "Cancelled - Clinician": "red",
  "Cancelled - Client": "red",
  "No Show - Charge Fee": "red",
  "No Show - No Fee": "red",
  Tentative: "#ffb514",
  Confirmed: "#23d117",
  Treated: "#23d117", // Lighter green color
  Completed: "#23d117", // Lighter green color
  Invoiced: "yellow",
  "Invoice Paid": "#23d117",
  "No Invoice Required": "#23d117",
  "Payment Failed": "red",
  "Soap Notes Saved": "yellow",
  "Soap Notes Updated": "orange",
  "Soap Notes Completed": "blue", // Completed by a clinician
  "Soap Notes Approved": "#23d117", // Approved by an SLP
  "No SOAP Required": "#23d117",
  "Clinician Payment Pending": "yellow",
  "Paid to Clinician": "#23d117", // Lighter green color
  incomplete: "gray",
  inProgress: "yellow",
  complete: "#23d117", // Lighter green color
  error: "red",
};

const getStatusFromHistory = (history, statusOptions) => {
  if (!history) return "incomplete";
  for (const status of statusOptions) {
    const latestStatus = history.find((h) => h.status === status);
    if (latestStatus) return latestStatus.status;
  }
  return "incomplete";
};

const StatusLights = ({ appointment }) => {
  const history = appointment?.history || [];

  const cancelledStatuses = [
    "Cancelled",
    "Cancelled - No Fee",
    "Cancelled - Charge Fee",
    "Cancelled - Clinician",
    "Cancelled - Client",
    "No Show",
    "No Show - No Fee",
    "No Show - Charge Fee",
  ];

  const isCancelled = history.some(
    (h) => h?.status && cancelledStatuses.includes(h.status)
  );
  const isNoFee = history.some((h) => h?.status && h.status.includes("No Fee"));

  const lights = [
    {
      label: "Appointment",
      status: getStatusFromHistory(history, [
        "Cancelled", // Prioritize Cancelled first
        "Cancelled - No Fee",
        "Cancelled - Charge Fee",
        "Cancelled - Clinician",
        "Cancelled - Client",
        "No Show - Charge Fee",
        "No Show - No Fee",
        "Completed",
        "Confirmed",
        "Tentative",
        "Changed",
        "Booked",
      ]),
    },
    {
      label: "Treated",
      status: history.some((h) => h.status === "Treated")
        ? "Treated"
        : "Not Treated",
    },
    {
      label: "Invoicing",
      status: isNoFee
        ? "No Invoice Required" // Bypass when appt is no fee
        : getStatusFromHistory(history, [
            "Payment Failed",
            "Invoice Paid",
            "Invoiced",
          ]),
    },
    {
      label: "Soap Notes",
      status: isCancelled
        ? "No SOAP Required" // Bypass when appt is cancelled / no showed
        : getStatusFromHistory(history, [
            "Soap Notes Approved",
            "Soap Notes Completed",
            "Soap Notes Updated",
            "Soap Notes Saved",
          ]),
    },
    {
      label: "Clinician Payment",
      status: getStatusFromHistory(history, [
        "Paid to Clinician",
        "Clinician Payment Pending",
      ]),
    },
  ];

  return (
    <div className="flex items-center gap-1 rounded-md p-1 bg-gray-200 w-fit">
      {lights.map((light) => (
        <div
          key={light.label}
          className="tooltip-container flex items-center relative">
          <div
            className={`w-2 h-2 rounded-full`}
            style={{ backgroundColor: lightColors[light.status] || "gray" }}
          />
          <span className="tooltip-text absolute bottom-full left-1/2 transform -translate-x-1/2 z-50">
            {light.label}: {light.status}
          </span>
        </div>
      ))}
    </div>
  );
};

export default StatusLights;
